import './src/globals/kv.scss'

import { wrapWithProvider } from './src/context/store'
export const wrapRootElement = wrapWithProvider
